module.exports = __webpack_public_path__ + "static/media/iconV.b0b2d15a.svg";